<svg
  [attr.viewBox]="viewBox"
  [attr.height]="height"
  [attr.width]="width"
  [style.height.px]="height"
  [style.width.px]="width"
  xmlns="http://www.w3.org/2000/svg"
  aria-label="Fraction"
>
  <svg *ngIf="outsideWidth" x="0" y="0%" [attr.width]="outsideWidth" height="100%">
    <!-- Outside -->
    <text
      *ngIf="!useTextInputOutside"
      x="50%"
      y="55%"
      dominant-baseline="middle"
      text-anchor="middle"
      [attr.fill]="color"
      [attr.font-size]="fontSize"
      [attr.font-family]="fontFamily"
      [attr.font-weight]="fontWeight"
    >
      {{ outside }}
    </text>

    <svg x="0" y="24%" width="100%" height="48%">
      <foreignObject
        class="input-wrapper"
        *ngIf="useTextInputOutside"
        x="0"
        y="0"
        width="100%"
        height="100%"
      >
        <body xmlns="http://www.w3.org/1999/xhtml">
          <input
            type="text"
            class="input"
            gameFocus
            msVirtualKeyboard
            [formControl]="outsideControl"
            [style.font-size.px]="fontSize"
            [style.font-family]="fontFamily"
            [style.font-weight]="fontWeight"
            [style.color]="color"
            [readonly]="readonly"
          />
        </body>
      </foreignObject>
    </svg>
  </svg>
  <svg [attr.x]="outsideWidth" y="0%" [attr.width]="fractionWidth" height="100%">
    <!-- Numerator -->
    <text
      *ngIf="!useTextInputNumerator"
      x="50%"
      y="39%"
      dominant-baseline="baseline"
      text-anchor="middle"
      [attr.fill]="color"
      [attr.font-size]="fontSize"
      [attr.font-family]="fontFamily"
      [attr.font-weight]="fontWeight"
    >
      {{ numerator }}
    </text>

    <svg x="0" y="0%" width="100%" height="48%">
      <foreignObject
        class="input-wrapper"
        *ngIf="useTextInputNumerator"
        x="0"
        y="0"
        width="100%"
        height="100%"
      >
        <body xmlns="http://www.w3.org/1999/xhtml">
          <input
            type="text"
            class="input"
            gameFocus
            msVirtualKeyboard
            [formControl]="numeratorControl"
            [style.font-size.px]="fontSize"
            [style.font-family]="fontFamily"
            [style.font-weight]="fontWeight"
            [style.color]="color"
            [readonly]="readonly"
          />
        </body>
      </foreignObject>
    </svg>

    <!-- Fraction Line -->
    <line
      x1="0%"
      y1="50%"
      x2="100%"
      y2="50%"
      [attr.stroke]="color"
      [attr.stroke-width]="strokeWidth"
    />

    <!-- Denominator -->
    <text
      *ngIf="!useTextInputDenominator"
      x="50%"
      y="81%"
      dominant-baseline="middle"
      text-anchor="middle"
      [attr.fill]="color"
      [attr.font-size]="fontSize"
      [attr.font-family]="fontFamily"
      [attr.font-weight]="fontWeight"
    >
      {{ denominator }}
    </text>

    <svg x="0" y="52%" width="100%" height="48%">
      <foreignObject
        class="input-wrapper"
        *ngIf="useTextInputDenominator"
        x="0"
        y="0"
        width="100%"
        height="100%"
      >
        <body xmlns="http://www.w3.org/1999/xhtml">
          <input
            type="text"
            class="input"
            gameFocus
            msVirtualKeyboard
            [formControl]="denominatorControl"
            [style.font-size.px]="fontSize"
            [style.font-family]="fontFamily"
            [style.font-weight]="fontWeight"
            [style.color]="color"
            [readonly]="readonly"
          />
        </body>
      </foreignObject>
    </svg>
  </svg>
</svg>
